/**
 * New Relic Browser configuration logic
 */
export const shouldEnableNewRelic = () => {
  // Must have license key and be explicitly enabled
  if (!process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || process.env.REACT_APP_NEW_RELIC_ENABLED !== 'true') {
    return false
  }
  // In local dev mode, require explicit permission
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_NEW_RELIC_ENABLE_DEV_MONITORING === 'true'
  }
  // In other environments (staging, production), allow if enabled
  return true
}

export const getNewRelicConfig = () => {
  if (!shouldEnableNewRelic()) {
    return null
  }

  return {
    info: {
      applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
      licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY
    },
    init: {
      distributed_tracing: {
        enabled: true
      },
      privacy: {
        cookies_enabled: true
      },
      ajax: {
        deny_list: ['bam.nr-data.net']
      }
    }
  }
}
